import TumengLine from './src/index.vue'

TumengLine.install = function(Vue) {
  Vue.component(TumengLine.name, TumengLine)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengLine)
}

export default TumengLine
